import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Stack, Paper, Divider } from "@mui/material";
import { formatDateTime } from "../../../utils/format";
import DoList from "../StorePoInfoPage/DoList";

function POBottomTabs({ ackMail, orderCfmMail, dos, poIdStrg, poStatus }) {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <Paper elevation={0} sx={{ p: 2, mt: 2, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 2 }}>
            {ackMail ? <Stack spacing={1} >
              <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{ackMail?.content}</Typography>
              <Typography variant="body2" fontWeight="light" sx={{ fontSize: 12 }}>
                Recipient : {ackMail?.recipients}</Typography>
              <Typography variant="body2" fontWeight="light" sx={{ fontSize: 12 }}> Sent : {formatDateTime(ackMail?.cAt)}</Typography>
            </Stack> : <Stack width={"100%"} alignItems={"center"} justifyContent={"center"} height={100}>
              Not Available
            </Stack>}
          </Paper>
        );
      case 1:
        return (
          <Paper elevation={0} sx={{ p: 2, mt: 2, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 2 }}>
            {orderCfmMail ? <Stack spacing={1} >
              <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{orderCfmMail?.content}</Typography>
              <Typography variant="body2" fontWeight="light" sx={{ fontSize: 12 }}>
                Recipient : {orderCfmMail?.recipients}</Typography>
              <Typography variant="body2" fontWeight="light" sx={{ fontSize: 12 }}> Sent : {formatDateTime(orderCfmMail?.cAt)}</Typography>
            </Stack> : <Stack width={"100%"} alignItems={"center"} justifyContent={"center"} height={100}>
              Not Available
            </Stack>}
          </Paper>
        );
      case 2:
        return (
          <Paper elevation={0} sx={{ p: 2, pb: 4, mt: 2, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 2 }}>
            {(poStatus !== "new" && poStatus !== "acknowledged") ? <Stack >
              <DoList height={"70vh"} dos={dos} poIdStrg={poIdStrg} poStatus={poStatus} />
            </Stack> : <Stack width={"100%"} alignItems={"center"} justifyContent={"center"} height={100}>
              Not Available
            </Stack>}
          </Paper>
        );
      default: return null;
    }
  };
  return (

    <Box sx={{ width: "100%" }}>
      <Divider />
      <Tabs value={activeTab} onChange={handleTabChange} textColor="inherit" indicatorColor="primary" >
        <Tab label="Acknowledgment" sx={{
          bgcolor: activeTab === 0 ? "primary.main" : "transparent",
          color: activeTab === 0 ? "black" : "rgba(0, 0, 0, 0.45)", borderRadius: "10px 10px 0 0",
          "&:hover": { bgcolor: "primary.light" },
        }} />
        <Tab label="Order Confirmation" sx={{
          bgcolor: activeTab === 1 ? "primary.main" : "transparent",
          color: activeTab === 1 ? "black" : "rgba(0, 0, 0, 0.45)", borderRadius: "10px 10px 0 0",
          "&:hover": { bgcolor: "primary.light" },
        }} />
        <Tab label="Delivery Orders" sx={{
          bgcolor: activeTab === 2 ? "primary.main" : "transparent",
          color: activeTab === 2 ? "black" : "rgba(0, 0, 0, 0.45)", borderRadius: "10px 10px 0 0",
          "&:hover": { bgcolor: "primary.light" },
        }} />
      </Tabs>
      <Box >
        <Divider sx={{ bgcolor: 'primary.main' }} />
        {renderContent()}
      </Box>
    </Box>

  )
}
export default POBottomTabs